
export const CREATE_PAGE_TITLE = `Добавление мода`

export const CREATE_INFO = `Чтобы добавить мод, заполните поля ниже. Ваш мод будет опубликован после успешного прохождения проверки.`

export const messages = `Добавление мода — Моды для Мир танков`
